

<!-- Mobile Hamburger Menu -->
<button (click)="toggleSidebar()" 
        class="fixed top-4 left-4    rounded-2xl z-50 lg:hidden"
        *ngIf="this.authService.accessToken && memberUrl">
  <mat-icon class="text-gray-700">
    {{ sidebarOpen ? 'close' : 'menu' }}
  </mat-icon>
</button>

<!-- Mobile Backdrop Overlay -->
<div *ngIf="sidebarOpen && isMobile && this.authService.accessToken && memberUrl"
     class="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
     (click)="toggleSidebar()">
</div>


<ng-container *ngIf="this.authService.accessToken && memberUrl">
    <!-- Desktop and Mobile Sidebar -->
    <div [ngClass]="{
      'translate-x-0': sidebarOpen,
      '-translate-x-full lg:translate-x-0 lg:w-14': !sidebarOpen,
      'w-60': sidebarOpen || !isMobile,
      'w-14': !sidebarOpen && !isMobile
    }" class="sidebar-container fixed top-0 left-0  h-screen shadow-xl flex flex-col z-50 transition-all duration-300 bg-gradient-to-br from-white via-accent-50 to-accent-100 !font-inter">
        
        <!-- Desktop Toggle Button (hidden on mobile) -->
        <div class="hidden lg:flex items-center justify-between px-2 py-3 space-x-2">
            <img (click)="toggleSidebar()"  class="w-15 items-center  cursor-pointer  " src="assets/images/logo/logo.png" alt="Logo image" loading="lazy" [ngClass]="sidebarOpen ? 'rounded-2xl ml-2' : 'rounded-full'"> 
             
        </div>

        <!-- Mobile Header with Close Button -->
        <div class="lg:hidden flex items-center justify-between px-4 py-4 border-b border-accent-200">
            <img class="w-15 items-center rounded-xl " src="assets/images/logo/logo.png" alt="Logo image" loading="lazy"> 
            <button (click)="toggleSidebar()" class="p-2 rounded group" >
                <mat-icon class="text-gray-600">close</mat-icon>
            </button>
        </div>

        <!-- Navigation -->
        <nav class="flex flex-col text-gray-700 h-full mt-4">
            <div class="flex flex-col space-y-2 flex-grow">
                <button *ngFor="let item of sidebarItems"
                    class="group relative px-2 mx-2 transition-colors flex items-center justify-start"
                    [ngClass]="{'py-1 h-12  ': !showLabels,'py-2 h-auto': showLabels,'text-primary-600 font-semibold': activePage === item.page}"
                    (click)="setActive(item.page); router.navigate([item.route])">
                    <span *ngIf="activePage === item.page"
                        class="absolute left-0 top-1 bottom-1 w-1 bg-primary-600 rounded-r"></span>
                    <mat-icon class="text-lg hover:text-primary-600">{{ item.icon }}</mat-icon>
                    <span *ngIf="showLabels" class="ml-4">
                        <h1 class="hover:text-primary-600 font-semibold">{{ item.label }}</h1>
                    </span>
                </button>
            </div>
            <button
                class="mt-auto group relative px-2 mx-2 transition-colors flex items-center py-4 h-auto justify-start text-black font-semibold hover:text-black"
                (click)="goHome()">
                <mat-icon class="text-lg">home</mat-icon>
                <span class="ml-4" *ngIf="showLabels">
                    Go Home
                </span>
            </button>
            <button (click)="logout()"
                class="mt-auto group relative px-2 mx-2 transition-colors flex items-center py-4 h-auto justify-start text-primary-600 font-semibold hover:text-black">
                <mat-icon class="text-lg">logout</mat-icon>
                <span class="ml-4" *ngIf="showLabels">
                    Log Out
                </span>
            </button>
        </nav>
    </div>
</ng-container>



<!-- Main App Content -->
<div *ngIf="this.authService.accessToken && memberUrl" [ngClass]="{
        'lg:ml-60': sidebarOpen && !isMobile,
        'lg:ml-14': !sidebarOpen && !isMobile,
        'ml-0': isMobile
    }" class="transition-all duration-300 p-4 min-h-screen overflow-x-hidden w-full bg-neutral-50 !font-inter">
    <router-outlet></router-outlet>
</div>

<router-outlet *ngIf="!memberUrl" class="!font-sans"></router-outlet>

<!-- WhatsApp Button for Landing Pages -->
<app-whatsapp-button></app-whatsapp-button>